<template>
    <div class="tenant-create-page" ref="formContainer">
        <div class="action d-flex position-absolute">
            <img @click="cancel" class="button-action margin-button" src="/images/icons/button-cancel.svg">
            <img @click="saveTenant" class="button-action margin-button" src="/images/icons/button-save.svg">
        </div>
        <div class="main-content">
            <Form :validation-schema="schema" v-slot="{ errors }" @submit="createTenant">
                <div class="info-tenant col-md-12 d-flex position-relative">
                    <div class="col-md-8">
                        <div class="info-text-tenant col-md-12 d-flex">
                            <div class="col-md-4 custom-width news-form__input">
                                <Field name="Section" class="form-control"
                                       :class="{ 'is-invalid': errors.Section }" v-model="tenant.section_id">
                                    <label class="news-form__title label-field"
                                           :class="errors.Section ? 'news-form__title--error' : ''">
                                        Select SECTION
                                    </label>
                                    <a-select
                                        v-model:value="tenant.section_id"
                                        show-search
                                        style="width: 100%"
                                        option-filter-prop="children"
                                        placeholder="Select SECTION"
                                        :options="listSection"
                                        :filter-option="filterOption"
                                        @change="handleChangeSection"
                                        :status="errors.Section ? 'error' : ''"
                                    >
                                        <a-select-option v-for="item in listSection" :key="item.value"
                                                         :value="item.value"
                                                         :label="item.label"
                                        >
                                            {{ item.label }}
                                        </a-select-option>
                                    </a-select>
                                    <div class="invalid-feedback d-inline-block">{{ errors.Section }}</div>
                                </Field>
                            </div>
                            <div class="col-md-4 custom-width news-form__input">
                                <Field name="Category" class="form-control"
                                       :class="{ 'is-invalid': errors.Category }" v-model="tenant.category_id">
                                    <label class="news-form__title label-field"
                                           :class="errors.Category ? 'news-form__title--error' : ''">
                                        Select CATEGORY
                                    </label>
                                    <a-select
                                        v-model:value="tenant.category_id"
                                        show-search
                                        style="width: 100%"
                                        option-filter-prop="children"
                                        placeholder="Select CATEGORY"
                                        :options="listCategory"
                                        :filter-option="filterOptionCategory"
                                        @change="handleChangeCategory"
                                        :status="errors.Category ? 'error' : ''"
                                    >
                                        <a-select-option v-for="item in listCategory" :key="item.value"
                                                         :value="item.value"
                                                         :label="item.label"
                                                         name="category"
                                        >
                                            {{ item.label }}
                                        </a-select-option>
                                    </a-select>
                                    <div class="invalid-feedback d-inline-block">{{ errors.Category }}</div>
                                </Field>
                            </div>
                            <div class="col-md-4 custom-width news-form__input">
                                <Field name="Floor" class="form-control"
                                       :class="{ 'is-invalid': errorFloor }" v-model="tenant.floor_id">
                                    <label class="news-form__title label-field"
                                           :class="errorFloor ? 'news-form__title--error' : ''">
                                        FLOOR NUMBER
                                    </label>
                                    <a-select
                                        v-model:value="tenant.floor_id"
                                        :options="listFloor"
                                        mode="multiple"
                                        :size="'middle'"
                                        placeholder="Select FLOOR"
                                        style="width: 100%"
                                        @change="handleChangeFloor"
                                        :status="errorFloor ? 'error' : ''"
                                    ></a-select>
                                    <div class="invalid-feedback d-inline-block">{{ errorFloorMessage }}</div>
                                </Field>
                            </div>
                        </div>
                        <div class="info-text-tenant col-md-12 d-flex">
                            <div class="col-md-4 custom-width news-form__input">
                                <Field name="Name" class="form-control" :class="{ 'is-invalid': errors.Name }"
                                       v-model="tenant.name">
                                    <label class="news-form__title label-field"
                                           :class="errors.Name ? 'news-form__title--error' : ''">
                                        Input TENANT NAME
                                    </label>
                                    <a-input :maxlength="255" @keydown.enter.prevent :status="errors.name ? 'error' : ''"
                                             v-model:value="tenant.name"/>
                                    <div class="invalid-feedback d-inline-block">{{ errors.Name }}</div>
                                </Field>
                            </div>
                            <div class="col-md-4 custom-width news-form__input">
                                <label class="news-form__title">
                                    Input HOTLINE
                                </label>
                                <a-input :maxlength="255" @keydown.enter.prevent v-model:value="tenant.hot_line"/>
                            </div>
                            <div class="col-md-4 custom-width position-relative check-box-create">
                                <a-checkbox v-model:checked="lsPointChecked">LS. POINT</a-checkbox>
                                <a-checkbox v-model:checked="lotteVoucher" style="margin-left: 100px">Lotte Voucher</a-checkbox>
                            </div>
                        </div>
                    </div>

                    <div class="info-image-tenant d-flex position-absolute">
                        <div class="tenant-logo news-form__thumb-input">
                            <Field v-model="tenant.tenant_logo" name="TenantLogo" class="form-control"
                                   :class="{ 'is-invalid': errors.TenantLogo }">
                                <label :class="errors.TenantLogo ? 'news-form__title--error' : ''"
                                       class="news-form__title label-field">TENANT
                                    LOGO</label>
                                <custom-upload-tenant
                                    v-model="tenant.tenant_logo"
                                    v-model:base64-string="base64Logo"
                                    :class="errors.TenantLogo ? 'news-form__upload-thumb--error' : ''"
                                    class="news-form__upload-thumb"
                                    name="TenantLogo"
                                    v-model:mess-error-tenant-logo="messErrorTenantLogo"
                                    v-model:upload-tenant-logo="uploadTenantImageLogo"
                                    v-model:open="open"
                                >
                                    <div v-if="!base64Logo">
                                        <img style="width: 100%;" src="/images/icons/blank-image.svg">
                                        <div class="news-form__thumb-btn">UPLOAD</div>
                                    </div>
                                    <div v-else class="news-form__thumb-preview">
                                        <img style="width: 100%;" :src="base64Logo" alt="Tenant LOGO"/>
                                    </div>
                                </custom-upload-tenant>
                                <div class="invalid-feedback custom-required-logo d-inline-block">{{
                                        errors.TenantLogo
                                    }}
                                </div>
                            </Field>
                        </div>
                        <div class="custom-margin news-form__thumb-input">
                            <Field v-model="tenant.tenant_image" name="TenantImage" class="form-control">
                                <label class="news-form__title">TENANT IMAGE</label>
                                <custom-upload-tenant
                                    v-model="tenant.tenant_image"
                                    v-model:base64-string-image="base64Image"
                                    class="news-form__upload-thumb"
                                    name="TenantImage"
                                    v-model:mess-error-tenant-image="messErrorImage"
                                    v-model:upload-tenant-image="uploadTenantImage"
                                    v-model:open="open"
                                >
                                    <div v-if="!base64Image">
                                        <img src="/images/icons/blank-image.svg">
                                        <div class="news-form__thumb-btn">UPLOAD</div>
                                    </div>
                                    <div v-else class="news-form__thumb-preview">
                                        <img :src="base64Image" alt="Tenant Image"/>
                                    </div>
                                </custom-upload-tenant>
                            </Field>
                            <p v-if="base64Image" class="removeTenantImage" @click="removeTenantImage()">Delete</p>
                        </div>
                    </div>
                </div>
                <div class="description-tenant col-md-12 d-flex">
                    <div class="col-md-6 news-form__input">
                        <Field name="DescriptionEN" class="form-control"
                               :class="{ 'is-invalid': errors.DescriptionEN }" v-model="tenant.description_en">
                            <label :class="errors.DescriptionEN ? 'news-form__title--error' : ''"
                                   class="news-form__title label-field">
                                Input TENANT DESCRIPTION-EN
                            </label>
                            <a-textarea :status="errors.DescriptionEN ? 'error' : ''"
                                        v-model:value="tenant.description_en"
                                        :rows="6"/>
                            <div class="invalid-feedback d-inline-block">{{ errors.DescriptionEN }}</div>
                        </Field>
                        <div class="d-flex col-md-12 justify-content-between list-tag">
                            <div class="col-md-2 news-form__inputTag hashtag" v-for="(hashtag, index) in listHashtag"
                                 :key="index">
                                <label class="news-form__hashtag">
                                    HASHTAG # {{ index + 1 }}
                                </label>
                                <a-input :maxlength="255" @keydown.enter.prevent v-model:value="hashtag.hash_tag"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 desc-vn news-form__input">
                        <Field name="DescriptionVN" class="form-control"
                               :class="{ 'is-invalid': errors.DescriptionVN }" v-model="tenant.description_vn">
                            <label :class="errors.DescriptionVN ? 'news-form__title--error' : ''"
                                   class="news-form__title label-field">
                                Input TENANT DESCRIPTION-VN
                            </label>
                            <a-textarea :status="errors.DescriptionVN ? 'error' : ''"
                                        v-model:value="tenant.description_vn"
                                        :rows="6"/>
                            <div class="invalid-feedback d-inline-block">{{ errors.DescriptionVN }}</div>
                        </Field>
                        <div class="d-flex col-md-12 justify-content-between list-tag">
                            <div class="col-md-2 news-form__inputTag hashtag" v-for="(hashtag, index) in listHashtag"
                                 :key="index">
                                <label class="news-form__hashtag">
                                    HASHTAG # {{ index + 1 }}
                                </label>
                                <a-input @keydown.enter.prevent v-model:value="hashtag.hash_tag_vn" :maxlength="255"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="collection col-md-12 mt-4">
                    <div class="info-collection">
                        <div class="d-flex collect-name">
                            <div class="col-md-6 news-form__input">
                                <label class="news-form__title label-field">
                                    COLLECTION NAME EN
                                </label>
                                <a-input :maxlength="255" :disabled="disabled" @keydown.enter.prevent v-model:value="tenant.collection_name"/>
                            </div>
                            <div class="col-md-6 desc-vn news-form__input">
                                <label class="news-form__title label-field">
                                    COLLECTION NAME VN
                                </label>
                                <a-input :maxlength="255" :disabled="disabled" @keydown.enter.prevent v-model:value="tenant.collection_name_vn"/>
                            </div>
                        </div>
                        <div class="d-flex collect-desc">
                            <div class="col-md-6 desc-vn news-form__input">
                                <label class="news-form__title label-field">
                                    COLLECTION DESCRIPTION EN
                                </label>
                                <a-textarea :disabled="disabled" v-model:value="tenant.collection_description" :rows="4"/>
                            </div>
                            <div class="col-md-6 desc-vn news-form__input">
                                <label class="news-form__title label-field">
                                    COLLECTION DESCRIPTION VN
                                </label>
                                <a-textarea :disabled="disabled" v-model:value="tenant.collection_description_vn" :rows="4"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="collection-image col-md-12 mt-4">
                    <div class="text-center">
                        <img src="/images/icons/button-upload-image.svg" @click="$refs.collectionImage.click()">
                        <input accept="image/jpg, image/jpeg, image/png, image/svg+xml" name="collectionImage"
                               multiple type="file"
                               ref="collectionImage" @change="uploadCollectionImage"
                               class="d-none"/>
                    </div>
                    <div class="text-center d-flex custom-margin-top">
                        <div v-if="isUploadCollectionImage" v-for="(image, index) in listShowCollectionUpload"
                             :key="index">
                            <img class="list-image-collection" :src="image">
                            <p class="removeImageCollection" @click="removeCollectionImage($event, index)">
                                Delete</p>
                        </div>
                    </div>
                    <div
                        class="text-danger input-group"
                        role="alert"
                        v-if="messErrorCollectionImage"
                    >
                        {{ messErrorCollectionImage }}
                    </div>
                </div>
                <div>
                    <button ref="createTenant" type="submit" class="d-none">Submit</button>
                    <button type="reset" class="btn btn-secondary d-none">Reset</button>
                </div>
            </Form>
            <a-modal :closable="false" :footer="null" v-model:open="open" :bodyStyle="{ height: '80px'}"
                     @cancel="onCancel">
                <div class="position-relative">
                    <p style="color: red">{{ messErrorTenantLogo }}</p>
                    <p style="color: red">{{ messErrorImage }}</p>
                    <button @click="onOk" style="right: 0" type="button" class="btn btn-primary position-absolute">Ok
                    </button>
                </div>
            </a-modal>
        </div>
    </div>
</template>

<script>
import SideNavSelect from "../reusable/SideNavSelect.vue";
import {
    LS_POINT,
    NOT_LS_POINT,
    MAX_SIZE_IMAGE_TENANT_UPLOAD,
    REMOVE_IMAGE,
    MAX_UPLOAD_ALL_COLLECTION,
    NOT_REMOVE_IMAGE
} from "../../const";
import {Form, Field, ErrorMessage} from 'vee-validate';
import * as yup from 'yup';
import {useToast} from "vue-toastification";
import CustomUploadTenant from "../reusable/CustomUploadTenant.vue";

const filterOption = (input, option) => {
    return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};
const filterOptionCategory = (input, option) => {
    return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};
const filterOptionFloor = (input, option) => {
    return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};

export default {
    name: 'NewTenantContent',
    setup() {
        const toast = useToast();
        return {toast}
    },
    components: {
        CustomUploadTenant,
        SideNavSelect,
        Form, Field, ErrorMessage,
    },
    created() {
        this.getListFloor()
        this.getListSection()
    },
    data() {
        const schema = yup.object({
            Section: yup.number().required(),
            Category: yup.number().required(),
            Name: yup.string().required(),
            Floor: yup.array().of(yup.string().required()),
            DescriptionEN: yup.string().required(),
            DescriptionVN: yup.string().required(),
            TenantLogo: yup.string().required(),
        });
        return {
            schema,
            selectSection: '',
            listSection: [],
            listCategory: [],
            listFloor: [],
            filterOption,
            filterOptionCategory,
            filterOptionFloor,
            LS_POINT,
            NOT_LS_POINT,
            MAX_SIZE_IMAGE_TENANT_UPLOAD,
            REMOVE_IMAGE,
            NOT_REMOVE_IMAGE,
            MAX_UPLOAD_ALL_COLLECTION,
            lsPointChecked: false,
            lotteVoucher: false,
            uploadTenantImage: true,
            messErrorImage: "",
            messErrorTenantLogo: "",
            uploadTenantImageLogo: true,
            base64Logo: null,
            base64Image: null,
            messErrorCollectionImage: '',
            isUploadCollectionImage: false,
            isCancel: false,
            open: false,
            errorFloor: false,
            errorFloorMessage: '',
            tenant: {
                name: '',
                hot_line: '',
                section_id: undefined,
                section_name: '',
                category_id: undefined,
                category_name: '',
                floor_id: [],
                tenant_logo: '',
                tenant_image: '',
                description_vn: '',
                description_en: '',
                collection_name: '',
                collection_name_vn: '',
                collection_description: '',
                collection_description_vn: '',
            },
            listHashtag: [
                {hash_tag_vn: '', hash_tag: ''},
                {hash_tag_vn: '', hash_tag: ''},
                {hash_tag_vn: '', hash_tag: ''},
                {hash_tag_vn: '', hash_tag: ''},
                {hash_tag_vn: '', hash_tag: ''},
            ],
            listFileCollectionUpload: [],
            listShowCollectionUpload: [],
            fullPage: true,
            disabled: false
        }
    },
    methods: {
        handleChangeSection(value, item) {
            this.disabled = false
            this.tenant.section_name = item.label
            this.tenant.category_id = undefined
            this.getListCategory(value)

            if (item.label == 'F&B') {
                this.disabled = true
            }
        },
        handleChangeCategory(value, item) {
            this.tenant.category_name = item.label
        },
        handleChangeFloor(value) {
            if (value.length == 0) {
                this.errorFloor = true
                this.errorFloorMessage = 'Floor is a field required'
            } else {
                this.errorFloor = false
                this.errorFloorMessage = ''
            }
        },
        getListSection() {
            let app = this;
            axios.get('/admin/sections/getListSection').then(response => {
                app.listSection = response.data.slice(1)
            });
        },
        getListCategory(section_id) {
            let app = this;
            let params = {
                section_id: section_id
            }
            axios.get('/admin/categories/getListCategory', {params: params}).then(response => {
                app.listCategory = response.data.slice(1)
            });
        },
        getListFloor() {
            let app = this;
            axios.get('/admin/floors/getListFloor').then(response => {
                app.listFloor = response.data
            });
        },

        uploadCollectionImage(e) {
            let files = e.target.files;
            this.listCollectionUpload = [];
            this.listShowCollectionUpload = []
            let result = this.checkCollectionUpload(files);

            if (!result) {
                this.isUploadCollectionImage = true
            }
        },
        removeCollectionImage(e, index) {
            this.listShowCollectionUpload.splice(index, 1)
            this.listCollectionUpload.splice(index, 1)
        },
        checkCollectionUpload(images) {
            var totalFileSize = 0;
            var fileReg = /[\/.](jpg|jpeg|png|svg|JPEG|JPG|PNG|SVG)$/i

            if (images.length > MAX_UPLOAD_ALL_COLLECTION) {
                this.isShowMessageCollectionImage = true
                this.messErrorCollectionImage = "You have uploaded more than the specified number of photos"
            } else {
                for (let image of images) {
                    let fileName = image.name;
                    if (!fileReg.test(fileName)) {
                        this.isShowMessageCollectionImage = true
                        this.messErrorCollectionImage = "Uploaded file is not in the correct format"
                    } else {
                        totalFileSize += image.size;
                        let reader = new FileReader();
                        reader.readAsDataURL(image);
                        this.listShowCollectionUpload.push(URL.createObjectURL(image));
                        this.listFileCollectionUpload.push(image);
                        this.isShowMessageCollectionImage = false;
                        this.messErrorCollectionImage = "";
                        this.sysError = {};
                    }
                }

                if ((totalFileSize / (1024 * 1024)) > MAX_UPLOAD_ALL_COLLECTION) {
                    this.listShowCollectionUpload = [];
                    this.isShowMessageCollectionImage = true
                    this.messErrorCollectionImage = 'Maximum file upload size exceeded'
                }
            }

            return this.isShowMessageCollectionImage;
        },
        saveTenant() {
            if (this.tenant.floor_id.length == 0) {
                this.errorFloor = true
                this.errorFloorMessage = 'Floor is a field required'
            }

            this.$refs.createTenant.click();
        },
        createTenant() {
            if (!this.messErrorTenantLogo && !this.messErrorImage && !this.errorFloor) {
                let loader = this.$loading.show({
                    // Optional parameters
                    container: this.fullPage ? null : this.$refs.formContainer,

                });
                let data = new FormData();
                var that = this
                let infoTenant = this.tenant
                data.append("lsPointChecked", this.lsPointChecked);
                data.append("lotteVoucher", this.lotteVoucher);
                data.append("isUploadCollectionImage", this.isUploadCollectionImage);
                infoTenant.listFileCollectionUpload = this.listFileCollectionUpload
                infoTenant["listFileCollectionUpload"].forEach(item => {
                    data.append("listFileCollectionUpload" + "[]", item)
                })
                infoTenant.listHashtag = this.listHashtag

                for (let key in infoTenant) {
                    if (typeof infoTenant[key] === "object") {
                        if (Array.isArray(infoTenant[key])) {
                            infoTenant[key].forEach(item => {
                                data.append(key + "[]", JSON.stringify(item))
                            })
                        } else {
                            data.append(key, JSON.stringify(infoTenant[key]))
                        }
                    } else {
                        data.append(key, infoTenant[key]);
                    }
                }

                data.append("imageUpload", infoTenant.tenant_image ? infoTenant.tenant_image : '');
                data.append("tenantLogoUpload", infoTenant.tenant_logo);
                axios.post('/admin/tenants/create', data).then(response => {
                    if (response.data.result) {
                        loader.hide();
                        that.isRemoveClass = true
                        that.isShowMessageCollectionImage = false
                        that.messErrorCollectionImage = ''
                        that.emitter.emit("removeClass", this.isRemoveClass);
                        that.toast.success('Create Tenant Successfully', {
                            position: "top-right",
                            timeout: 3000,
                            closeOnClick: true,
                            pauseOnFocusLoss: true,
                            pauseOnHover: true,
                            draggable: true,
                            draggablePercent: 0.6,
                            showCloseButtonOnHover: false,
                            hideProgressBar: true,
                            closeButton: "button",
                            icon: true,
                            rtl: false
                        });
                    }
                }).catch((error) => {
                    that.toast.error("An error has occurred!", {
                        position: "top-right",
                        timeout: 3000,
                        closeOnClick: true,
                        pauseOnFocusLoss: true,
                        pauseOnHover: true,
                        draggable: true,
                        draggablePercent: 0.6,
                        showCloseButtonOnHover: false,
                        hideProgressBar: true,
                        closeButton: "button",
                        icon: true,
                        rtl: false
                    });
                });
            }
        },
        cancel() {
            this.isCancel = true;
            this.emitter.emit("cancel", this.isCancel);
        },
        onOk() {
            this.open = false

            if (this.messErrorTenantLogo) {
                this.messErrorTenantLogo = '';
            }

            if (this.messErrorImage) {
                this.messErrorImage = '';
            }
        },
        onCancel() {
            if (this.messErrorTenantLogo) {
                this.messErrorTenantLogo = '';
            }

            if (this.messErrorImage) {
                this.messErrorImage = '';
            }
        },
        removeTenantImage() {
            this.base64Image = null
            this.tenant.tenant_image = ''
        }
    },
};
</script>
